// frontend/src/components/PlatformUtils/PlatformUtils.jsx

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import XIcon from '@mui/icons-material/X';
import GoogleIcon from '@mui/icons-material/Google';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import RedditIcon from '@mui/icons-material/Reddit';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import ChatIcon from '@mui/icons-material/Chat';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TelegramIcon from '@mui/icons-material/Telegram';
import LanguageIcon from '@mui/icons-material/Language';
import BlockIcon from '@mui/icons-material/Block';
import PinterestIcon from '@mui/icons-material/Pinterest';

export function QuoraIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12.555 17.025c-.624-1.227-1.354-2.465-2.781-2.465-.271 0-.546.046-.795.157l-.484-.967c.59-.509 1.544-.911 2.77-.911 1.908 0 2.889.922 3.667 2.094.459-1.001.678-2.354.678-4.03 0-4.188-1.308-6.336-4.366-6.336-3.014 0-4.318 2.148-4.318 6.336 0 4.164 1.305 6.291 4.318 6.291.478 0 .913-.051 1.311-.169zm.747 1.461a7.977 7.977 0 0 1-2.059.274c-4.014 0-7.941-3.202-7.941-7.858C3.303 6.203 7.229 3 11.243 3c4.081 0 7.972 3.179 7.972 7.903 0 2.628-1.226 4.763-3.007 6.143.572.861 1.157 1.436 1.988 1.436.899 0 1.261-.687 1.328-1.236h1.167c.07.73-.301 3.754-3.574 3.754-1.989 0-3.035-1.146-3.822-2.496l.007-.018z"
      />
    </SvgIcon>
  );
}

export function ThreadsIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.964-.065-1.19.408-2.285 1.33-3.082.88-.76 2.119-1.207 3.583-1.291a13.853 13.853 0 0 1 3.02.142c-.126-.742-.375-1.332-.75-1.757-.513-.586-1.308-.883-2.359-.89h-.029c-.844 0-1.992.232-2.721 1.32L7.734 7.847c.98-1.454 2.568-2.256 4.478-2.256h.044c3.194.02 5.097 1.975 5.287 5.388.108.046.216.094.321.142 1.49.7 2.58 1.761 3.154 3.07.797 1.82.871 4.79-1.548 7.158-1.85 1.81-4.094 2.628-7.277 2.65Zm1.003-11.69c-.242 0-.487.007-.739.021-1.836.103-2.98.946-2.916 2.143.067 1.256 1.452 1.839 2.784 1.767 1.224-.065 2.818-.543 3.086-3.71a10.5 10.5 0 0 0-2.215-.221z"
      />
    </SvgIcon>
  );
}

export function TiktokIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"
      />
    </SvgIcon>
  );
}

export function TwitchIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"
      />
    </SvgIcon>
  );
}

export const PLATFORM_ICONS = {
    google: <GoogleIcon fontSize="small" />,
    meta: <FacebookIcon fontSize="small" />,
    facebook: <FacebookIcon fontSize="small" />,
    instagram: <InstagramIcon fontSize="small" />,
    tiktok: <TiktokIcon fontSize="small" />,
    twitter: <XIcon fontSize="small" />,
    x: <XIcon fontSize="small" />,
    youtube: <YouTubeIcon fontSize="small" />,
    linkedin: <LinkedInIcon fontSize="small" />,
    pinterest: <PinterestIcon fontSize="small" />,
    quora: <QuoraIcon fontSize="small" />,
    reddit: <RedditIcon fontSize="small" />,
    snapchat: <ChatIcon fontSize="small" />,
    telegram: <TelegramIcon fontSize="small" />,
    threads: <ThreadsIcon fontSize="small" />,
    whatsapp: <WhatsAppIcon fontSize="small" />,
    twitch: <TwitchIcon fontSize="small" />,
    news_site: <NewspaperIcon fontSize="small" />,
    messaging_app: <ChatIcon fontSize="small" />,
    other: <LanguageIcon fontSize="small" />,
};

export const getPlatformDisplayName = (platform, t) => {
    if (!platform) return '';
    const key = platform.toLowerCase();
    
    // Normalize backend keys to their modern equivalents for translation mapping
    let transKey = key;
    if (key === 'facebook') transKey = 'meta';
    if (key === 'twitter') transKey = 'x';

    // Check if translation exists
    const translated = t(`contentInput.context.platforms.${transKey}`, { defaultValue: '' });
    
    if (translated && translated !== `contentInput.context.platforms.${transKey}`) {
        return translated;
    }

    // Fallback formatting
    return platform.charAt(0).toUpperCase() + platform.slice(1);
};

export const getPlatformOptions = (t) => {
    const platformKeys = [
        'google', 'instagram', 'linkedin', 'messaging_app', 'meta', 'news_site',
        'pinterest', 'quora', 'reddit', 'snapchat', 'threads', 'telegram', 'tiktok',
        'twitch', 'whatsapp', 'x', 'youtube'
    ];

    const platforms = platformKeys.map(key => ({
        value: key,
        label: getPlatformDisplayName(key, t),
        icon: PLATFORM_ICONS[key] || <LanguageIcon fontSize="small" />
    }));

    // 1. Sort Alphabetically
    platforms.sort((a, b) => a.label.localeCompare(b.label));

    // 2. Add "Other" at the end
    platforms.push({ 
        value: 'other', 
        label: getPlatformDisplayName('other', t), 
        icon: PLATFORM_ICONS['other'] 
    });

    // 3. Add "Select Platform" (Reset) at the start
    platforms.unshift({ 
        value: '', 
        label: t('contentInput.context.platformPlaceholder', { defaultValue: 'Select Platform' }), 
        icon: <BlockIcon fontSize="small" /> 
    });

    return platforms;
};